<ca-modal-container [modalTitle]="title" (dismiss)="close()" data-uit="modal-info">
    <div class="d-flex mt-3">
        <p>{{ message }}</p>
    </div>
</ca-modal-container>
<div class="d-flex">
    <button type="button" caAutoFocus class="w-100 btn btn-primary" (click)="close()" data-uit="modal-info-done-button">
        {{ buttonText }}
    </button>
    <button
        *ngIf="isAtDatasetList"
        type="button"
        caAutoFocus
        class="w-100 btn btn-secondary"
        (click)="openDataset(currentDataset?.datasetId)"
        data-uit="modal-info-dataset-detail-button"
    >
        {{ conversionStatusButtonText }}
    </button>
</div>
